import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Transition as _Transition, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45ea2485"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row items-center q-py-sm q-px-xs text-white bg-primary" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data-axis text-subtitle2 q-mr-md" }, "Data (MB)", -1))
const _hoisted_3 = { class: "charts-css column justify-center show-heading show-labels show-6-secondary-axes data-spacing-3 show-y-axes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Total Usage")
  ])
], -1))
const _hoisted_5 = { scope: "row" }
const _hoisted_6 = {
  key: 0,
  class: "absolute-center row items-center justify-center",
  style: {"width":"500px","height":"300px"}
}

import 'charts.css';
import _floor from 'lodash/floor';
import { useDialogPluginComponent } from 'quasar';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useDeviceBySerial } from 'composables/device';
import { useDeviceSim } from 'composables/device-sim';
import { useDayjs } from 'composables/dayjs';
import { useFormat } from 'composables/format';
import SimSourceBadge from 'components/device/SimSourceBadge.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimUsageDialog',
  props: {
    serial: null
  },
  setup(__props: any) {

const props = __props as {
  serial: string;
};



const serial = computed(() => props.serial);

const { device } = useDeviceBySerial(serial);

const { isLoading, simUsage } = useDeviceSim(serial);

const simUsageInMb = computed(() =>
  simUsage.value.map((usage) => ({
    ...usage,
    total: usage.total / 1024,
  }))
);

const maxSimUsage = computed(() =>
  simUsageInMb.value.reduce((max, usage) => (usage.total > max ? usage.total : max), 0)
);

const scaledMax = computed(() => {
  if (maxSimUsage.value === 0) {
    return 1;
  }

  const aTenth = maxSimUsage.value / 10;
  const ceilingAdd = maxSimUsage.value + aTenth;
  return ceilingAdd;
});

const last7Days = computed(() => {
  const days = [...Array(7)].map((_, index) => ({
    date: dayjs().subtract(index, 'days'),
    total: 0,
  }));
  days.reverse();
  return days;
});

const tableData = computed(() => {
  if (isLoading.value) {
    return last7Days.value;
  } else {
    if (simUsageInMb.value.length < 7) {
      // Index existing days by date
      const dayData: { [date: string]: number } = {};

      simUsageInMb.value.forEach(({ date, total }) => {
        dayData[dayjs(date).format('YYYYMMDD')] = total;
      });

      return last7Days.value.map(({ date, total }) => {
        const dateString = date.format('YYYYMMDD');
        return {
          date,
          total: dayData[dateString] || total,
        };
      });
    } else {
      return simUsageInMb.value;
    }
  }
});

const { dialogRef } = useDialogPluginComponent();

const { dayjs } = useDayjs();

const { thousandsComma } = useFormat();

const router = useRouter();
const route = useRoute();

function onHide() {
  if (route.name === 'accountDeviceSimUsage') {
    router.push({
      name: 'accountDevice',
      params: { key: route.params.key, serial: route.params.serial },
    });
  } else if (route.name === 'accountlessDeviceSimUsage') {
    router.push({
      name: 'accountlessDevice',
      params: { serial: route.params.serial },
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_spinner_audio = _resolveComponent("q-spinner-audio")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: onHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-dialog__title q-pa-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_badge, { class: "q-mx-sm q-py-sm q-px-md bg-white" }, {
                  default: _withCtx(() => [
                    _createVNode(SimSourceBadge, {
                      scale: 1.4,
                      source: _unref(device).simSource
                    }, null, 8, ["scale", "source"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, "SIM Usage | Serial #" + _toDisplayString(_unref(serial)), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["chart q-px-md q-py-md", { loaded: !_unref(isLoading) }])
              }, [
                _hoisted_2,
                _createElementVNode("table", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableData), (usage, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(dayjs)(usage.date).format('M/D')), 1),
                        _createElementVNode("td", {
                          style: _normalizeStyle(`--size: calc(${usage.total} / ${_unref(scaledMax)})`)
                        }, _toDisplayString(!usage.total ? '' : _unref(thousandsComma)(Math.ceil(usage.total))), 5)
                      ]))
                    }), 128))
                  ])
                ])
              ], 2)
            ]),
            _: 1
          }),
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_q_spinner_audio, {
                  color: "grey-3",
                  size: "200px"
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_q_btn, {
                flat: "",
                label: "Close",
                padding: "xs md"
              }, null, 512), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})